import { render } from "./BudgetShow.vue?vue&type=template&id=d8c022ea&scoped=true"
import script from "./BudgetShow.vue?vue&type=script&lang=js"
export * from "./BudgetShow.vue?vue&type=script&lang=js"

import "./BudgetShow.vue?vue&type=style&index=0&id=d8c022ea&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c022ea"]])

export default __exports__